<!-- 客户管理 客户列表 商品管理 产品上架-->
<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="80"></el-table-column>
          <el-table-column label="产品编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="PRICE">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRICE" :placeholder="scope.row.PRICE"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="开始日期" prop="START_DAY" v-if="userPriceType == 2">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.START_DAY" align="right" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:100%">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="结束日期" prop="END_DAY" v-if="userPriceType == 2">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.END_DAY" align="right" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:100%">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="downData(scope.row)">上架</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      pageSize: 40,
      currentPage: 1,
      totalCount: 0,
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      // PRICE: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
  methods: {
    // ---------------上架
    downData(row) {
      if (!validation.价格正数验证(row.PRICE)) {
        this.$message.show({ text: '请输入单价', type: 'warning' });
        return false;
      }
      this.$confirm('确定上架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 10,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(sessionStorage.getItem('TC_ID')),
          PRODUCT_CODE: row.INNER_CODE,
          PRICE: row.PRICE,
          PRICE_MODE: this.userPriceType,
          IS_USE_KG: row.IS_USE_KG,
        };
        if (this.userPriceType == 2) {
          params.START_DAY = row.START_DAY;
          params.END_DAY = row.END_DAY;
          // params.TC_PRODUCT_CODE = row.CUSTOMER_CODE;
          // params.CHANGE_RATE = row.PERCENT;
        }
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '上架成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码输入有误', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 9,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        // PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        PRICE_MODE: this.userPriceType,
      };
      if (this.searchForm.name && this.searchForm.name != '') {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code && this.searchForm.code != '') {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      http.post(params)
        .then((result) => {
          this.tableData = result[0].list.map((item) => Object.assign(item, { PRICE: '' }, { PERCENT: 1.0 }));
          this.totalCount = result[0].TOTAL;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    querySearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    handleChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/addProductsList.vue